export default function roundToNearestThousandToConveyUncertaintyInCalculations(
  value,
) {
  // eslint-disable-next-line no-magic-numbers
  return Math.round(value / 1000) * 1000;
}
